import { render, staticRenderFns } from "./Surfing10_Classic.vue?vue&type=template&id=2b3f6508&"
import script from "./Surfing10_Classic.vue?vue&type=script&lang=js&"
export * from "./Surfing10_Classic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports